import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';

export default class SettingsController extends Controller {
  @service router;
  @service intl;
  @service betaToggle;

  get tabs() {
    return [
      {
        label: this.intl.t('personals.account'),
        route: 'settings.account',
        key: 'account',
      },
      {
        label: this.intl.t('dictionary.organisation', { num: 2 }),
        route: 'settings.organisation',
        key: 'organisation',
      },
      {
        label: this.intl.t('dictionary.team', { num: 2 }),
        route: 'settings.teams.active',
        key: 'teams',
      },
      {
        label: this.intl.t('dictionary.roles', { num: 2 }),
        route: 'settings.roles',
        key: 'roles',
      },
      {
        label: this.intl.t('dictionary.financials'),
        route: 'settings.financials',
        key: 'financials',
        icon: 'tailwind-icons/lock-fill',
      },
      {
        label: this.intl.t('dictionary.themes', { num: 2 }),
        route: 'settings.tags',
        key: 'tags',
      },
      {
        label: this.intl.t('department.title', { num: 2 }),
        route: 'settings.departments.list',
        key: 'departments',
      },
      {
        label: this.intl.t('area.title', { num: 2 }),
        route: 'settings.areas.list',
        key: 'areas',
      },
      {
        label: this.intl.t('customer.title', { num: 2 }),
        route: 'settings.customers.list',
        key: 'customers',
        hide: !this.betaToggle.showIdeas,
      },
      {
        label: this.intl.t('group.title', { num: 2 }),
        route: 'settings.groups.list',
        key: 'groups',
        hide: !this.betaToggle.showGroups,
      },
      {
        label: this.intl.t('agents.title', { num: 2 }),
        route: 'settings.agents.list',
        key: 'agents',
        hide: !this.betaToggle.showChat,
      },
    ];
  }

  @action
  isActive(tab) {
    return this.router.currentRouteName?.includes(tab.key);
  }
}
